// Open a popup window with specified URL and options -- for social sharing, mainly
export const popup = (url, title = '', options = {}) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const top = (window.outerHeight / 2) + (window.screenY || window.screenTop || 0) - (options.height || 500 / 2);
  const left = (window.outerWidth / 2) + (window.screenX || window.screenLeft || 0) - (options.width || 500 / 2);

  const opts = {
    toolbar: 'no',
    location: 'no',
    directories: 'no',
    status: 'no',
    menubar: 'no',
    scrollbars: 'no',
    resizable: 'no',
    copyhistory: 'no',
    width: 500,
    height: 500,
    top,
    left,
    ...options,
  };

  return window.open(url, title, Object.keys(opts).map(key => `${key}=${opts[key]}`).join(', '));
};

// Get metadata details from the global object, with fallbacks
export const getMeta = (metaObject, context) => ({
  ...metaObject.site,
  ...(context !== 'site' ? metaObject.section : {}),
  ...(context === 'page' ? metaObject.page : {}),
});

// Convert a hex value and decimal opacity to rgba string
export const hexToRgba = (hex, opacity = 1) => {
  if (!hex) {
    return null;
  }
  hex = hex.replace('#', '');
  const parts = hex.length === 6 ? hex.match(/.{2}/g) : hex.split('').map(s => s + s);
  const [r, g, b] = parts.map(p => parseInt(p, 16));
  return `rgba(${r},${g},${b},${opacity})`;
};



// WEBPACK FOOTER //
// ./src/utils/index.js